import React, { useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  Divider,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Link, useLocation } from "react-router-dom";
// src
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import CheckAttendancePage from "./CheckAttendancePage";
import ViewAttendacePage from "./ViewAttendacePage";


export default function AttendenceCheck() {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let classId = params.get("id");
  let classtitle = params.get("class");

  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState("tab-attendance");

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);


  useEffect(() => {
    let getTabAttendance = JSON.parse(
      window.localStorage.getItem("tabAttendance")
    );
    if (getTabAttendance) {
      setTabValue(getTabAttendance);
    }
  }, []);

  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/attendance">
              <Typography
                className={language === "kh" ? "page-title-kh" : "page-title"}
              >
                {t(`page-attendance`)}
              </Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="slash-title">/</Typography>
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {classtitle}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>
      <Box sx={{ marginTop: "15px" }}>
        <Grid container spacing={2} className="tab-btn-celendar">
          <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
            <Button
              fullWidth
              onClick={() => {
                setTabValue("tab-attendance");
                window.localStorage.setItem(
                  "tabAttendance",
                  JSON.stringify("tab-attendance")
                );
              }}
              className={
                tabValue === "tab-attendance" ? "active-btn" : "in-active-btn"
              }
            >
              {t("check_attendance")}
            </Button>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3, lg: 2, xl: 2 }}>
            <Button
              fullWidth
              onClick={() => {
                setTabValue("tab-view-att");
                window.localStorage.setItem(
                  "tabAttendance",
                  JSON.stringify("tab-view-att")
                );
              }}
              className={
                tabValue === "tab-view-att" ? "active-btn" : "in-active-btn"
              }
            >
              {t("view_attendance")}
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box>
        {tabValue === "tab-attendance" ? (
          <CheckAttendancePage classId={classId} />
        ) : null}
        {tabValue === "tab-view-att" ? (
          <ViewAttendacePage classId={classId} />
        ) : null}
      </Box>
    </div>
  );
}
